import { Component, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { TableLazyLoadEvent } from 'primeng/table';
import { PromoSponsorService } from 'app/services';
import { Utils } from 'app/utils';

@Component({
    selector: 'promo-sponsor',
    templateUrl: './promo-sponsor.component.html',
    styleUrls: ['./promo-sponsor.component.scss',
        '../../../../styles/sidebar.scss'
    ],
    providers: [MessageService]
})
export class PromoSponsorComponent implements OnInit {

    public rowsPerPage: number = 50;
    public rowsPerPageOptions: Array<number> = [50, 100, 500, 1000];
    public totalRecords: number = 0;
    public first: number = 0;
    public sortField: string = 'Id';
    public sortOrder: number = -1;

    public loading: boolean = false;

    public sponsors: Array<any> = [];

    public filter: { SearchName: string } = { SearchName: '' };
    private filterTimeout: any;

    public showEditSideBar: boolean = false;
    public sponsor: any = {};

    public cols: any[] = [
        { field: 'Id', header: 'ID', width: '80px' },
        { field: 'Name', header: 'Name' },
        { field: 'CreatedAtStr', header: 'Created', width: '160px' }
    ];

    constructor(
        private messageService: MessageService,
        private promoSponsorService: PromoSponsorService) {
    }

    ngOnInit(): void {
        this.getSponsors(0);
    }

    public handleLazyLoad(event: TableLazyLoadEvent): void {
        const skip = event.first ? event.first : 0;

        if (event.rows) {
            this.rowsPerPage = event.rows;
        }

        if (!event.sortField) {
            this.sortField = 'Id';
            this.sortOrder = -1;
        }
        else {
            this.sortField = Array.isArray(event.sortField) ? event.sortField[0] : event.sortField;
            this.sortOrder = event.sortOrder ? event.sortOrder : 1;
        }

        this.getSponsors(skip);
    }

    public getSponsors(skip: number): void {
        this.loading = true;

        const dto = {
            SearchName: this.filter.SearchName,
            Skip: skip,
            Take: this.rowsPerPage,
            SortField: this.sortField,
            SortOrder: this.sortOrder
        };

        this.promoSponsorService.getSponsors(dto, this.messageService)
            .then(data => {
                if (!data || !data.Success) {
                    this.loading = false;
                    if (data) {
                        this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    }
                    return;
                }

                this.first = skip;
                this.totalRecords = data.TotalRecords;
                this.sponsors = (data.Items || []).map((x: any) => {
                    x.CreatedAtStr = Utils.utcToLocaleStringDateFormat(x.CreatedAt);
                    return x;
                });
                this.loading = false;
            })
            .catch(err => {
                this.loading = false;
                throw err;
            });
    }

    public handleHeaderFilterChange(): void {
        clearTimeout(this.filterTimeout);
        this.filterTimeout = setTimeout(() => {
            this.getSponsors(0);
        }, 800);
    }

    public openCreate(): void {
        this.sponsor = { Id: 0, Name: '', IsActive: true };
        this.showEditSideBar = true;
    }

    public openEdit(item: any): void {
        this.sponsor = {
            Id: item.Id,
            Name: item.Name,
            IsActive: item.IsActive
        };
        this.showEditSideBar = true;
    }

    public closeSideBar(): void {
        this.showEditSideBar = false;
    }

    public save(): void {
        if (!this.sponsor.Name || !this.sponsor.Name.trim()) {
            this.messageService.add({ severity: 'error', summary: 'Warning', detail: 'Name is required.' });
            return;
        }

        this.loading = true;

        this.promoSponsorService.addOrUpdateSponsor(this.sponsor, this.messageService)
            .then(data => {
                this.loading = false;
                if (!data) {
                    return;
                }
                if (!data.Success) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }
                this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Sponsor saved.' });
                this.showEditSideBar = false;
                this.getSponsors(this.first);
            })
            .catch(err => {
                this.loading = false;
                throw err;
            });
    }

    public switchActive(item: any): void {
        const dto = {
            SponsorId: item.Id,
            IsActive: item.IsActive
        };

        this.promoSponsorService.setSponsorActive(dto, this.messageService)
            .then(data => {
                if (!data || !data.Success) {
                    item.IsActive = !item.IsActive;
                    if (data) {
                        this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    }
                }
            })
            .catch(err => {
                item.IsActive = !item.IsActive;
                throw err;
            });
    }
}
